import { QuickAdd } from "~/components/admin/dispatch";
import PageMeta from "~/components/common/meta";

export const ScreenQuickAdd = () => {
  return (
    <>
      <PageMeta title="Quick Add | Art Handler" description="Quick Add" />
      <QuickAdd />
    </>
  );
};
